import { useEffect, useState } from "react";
import { emitErrorToast } from "../../lib/errorToast";
import { downloadFile } from "./download";
import type { FileRenderControl } from "./types";

async function downloadOutput(
  url: string | undefined,
  fileName: string,
  setDownloading: (downloading: boolean) => void
) {
  if (!url) return;
  setDownloading(true);
  await downloadFile(url, fileName)
    .catch(() => {
      emitErrorToast({
        icon: "circle-off",
        message: "Couldn’t download this file. Please try again.",
        buttonLabel: "Dismiss",
      });
    })
    .finally(() => setDownloading(false));
}

export function useFileActions({
  url,
  fileName,
  onControls,
  controlId = "download-file",
  label = "Download",
}: {
  url: string | undefined;
  fileName: string;
  onControls?: (controls: FileRenderControl[]) => void;
  controlId?: string;
  label?: string;
}) {
  const [downloading, setDownloading] = useState(false);
  useEffect(() => {
    if (!onControls) return;
    onControls([
      {
        id: controlId,
        icon: "circle-arrow-down",
        label: downloading ? "Downloading…" : label,
        disabled: !url || downloading,
        onToggle: () => void downloadOutput(url, fileName, setDownloading),
      },
    ]);
    return () => onControls([]);
  }, [onControls, url, fileName, controlId, label, downloading]);
  return {
    downloading,
    download: () => {
      if (!downloading) void downloadOutput(url, fileName, setDownloading);
    },
  };
}
